import { create } from 'zustand';

interface ModalState {
  openObjectId: string | null;
  highlightBlockId: string | null; // Block ID to highlight/scroll to when opening object
  navigationHistory: string[]; // Stack of object IDs
  openObjectModal: (id: string, blockId?: string) => void;
  closeObjectModal: () => void;
  navigateBack: () => void;
  clearHistory: () => void;
}

export const useModalStore = create<ModalState>((set, get) => ({
  openObjectId: null,
  highlightBlockId: null,
  navigationHistory: [],

  openObjectModal: (id: string, blockId?: string) => {
    const { openObjectId, navigationHistory } = get();

    // If we're currently viewing an object, add it to history
    if (openObjectId && openObjectId !== id) {
      set({
        openObjectId: id,
        highlightBlockId: blockId || null,
        navigationHistory: [...navigationHistory, openObjectId]
      });
    } else {
      // First object or same object, just set it
      set({
        openObjectId: id,
        highlightBlockId: blockId || null
      });
    }
  },

  closeObjectModal: () => set({
    openObjectId: null,
    highlightBlockId: null,
    navigationHistory: [] // Clear history when closing modal
  }),

  navigateBack: () => {
    const { navigationHistory } = get();

    if (navigationHistory.length > 0) {
      // Pop the last item from history
      const newHistory = [...navigationHistory];
      const previousId = newHistory.pop()!;

      set({
        openObjectId: previousId,
        navigationHistory: newHistory
      });
    } else {
      // No history, close modal
      set({ openObjectId: null });
    }
  },

  clearHistory: () => set({ navigationHistory: [] }),
}));
